<div id="layout" class="f_col">
  <app-view-title fromRoute="document-management" [chooseLangBtn]="false">{{'session.inactive.title' | translate}}</app-view-title>
  <div class="scroll_wrapper resp_wrapper">
    <div class="resp_c-50 resp_scroll-wrapper_l blocked-container">
        <app-view-deco-image imageUrl="assets/images/image_warn.svg"></app-view-deco-image>
        <app-paragraph>{{'session.inactive' | translate}}</app-paragraph>
        <app-button size="sm" class="reactivate-button resp_minSize_l" (btnClicked)="reactivateSession()">{{'reactivateSession' | translate}}</app-button>
    </div>
  </div>
  <div class="mb_20 resp_maxSize_l flex gap_10">
      <app-button class="fullWidth" (btnClicked)="reactivateSession()">{{'reactivateSession' | translate}}</app-button>
  </div>
</div>
